(function initVatRegistrationDate(global) {
  // Om foretaket kan bruke MVA paa en gitt bilagsdato. Regelen speiler
  // isVatRegisteredOnDate i functions/assistant/router/countryVat.ts, som avviser
  // MVA utenfor registreringsperioden ved lagring. Her brukes den bare til aa
  // skjule MVA-valg brukeren uansett ikke faar lagre.
  const isIsoDate = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

  const registeredOn = (settings = {}, date) => {
    const registeredFrom = isIsoDate(settings?.vatRegisteredFrom) ? settings.vatRegisteredFrom : '';
    const deregisteredFrom = !settings?.vatRegistered && isIsoDate(settings?.vatDeregisteredFrom) ? settings.vatDeregisteredFrom : '';
    if (registeredFrom) return date >= registeredFrom && (!deregisteredFrom || date < deregisteredFrom);
    return Boolean(settings?.vatRegistered) && (!deregisteredFrom || date < deregisteredFrom);
  };

  // Serveren sjekker bare datoen naar innstillingene har registreringsstatus.
  const hasRegistrationState = (settings = {}) => (
    Object.prototype.hasOwnProperty.call(settings || {}, 'vatRegistered') || isIsoDate(settings?.vatRegisteredFrom)
  );

  const currentSettings = () => global.PlummeBackend?.appState?.settings || {};

  // Uten dato (produktkatalog og lignende) gjelder bare ja/nei-valget, slik appen
  // alltid har gjort.
  const allowsVatOn = (date, settings = currentSettings()) => {
    if (!isIsoDate(date)) return settings?.vatRegistered !== false;
    if (!hasRegistrationState(settings)) return true;
    return registeredOn(settings, date);
  };

  global.PlummeVatRegistration = { allowsVatOn, registeredOn, hasRegistrationState };
})(typeof window !== 'undefined' ? window : globalThis);
